export const labels = {
  VL: {
    title: 'Wet & Cold',
    temperatureLabel: 'Very Low Temperature',
    precipitationLabel: 'High Precipitation',
  },
  VH: {
    title: 'Very Hot & Dry',
    temperatureLabel: 'Very High Temperature',
    precipitationLabel: 'Low Precipitation',
  },
  L: {
    title: 'Cool & Rainy',
    temperatureLabel: 'Low Temperature',
    precipitationLabel: 'High Precipitation',
  },
  H: {
    title: 'Warm & Dry',
    temperatureLabel: 'High Temperature',
    precipitationLabel: 'Low Precipitation',
  },
  M: {
    title: 'Mild',
    temperatureLabel: 'Medium Temperature',
    precipitationLabel: 'Medium Precipitation',
  },
};

export const productPerformanceDisplayCategoryBySource = {
  H: 'H',
  L: 'L',
  M: 'M',
  VH: 'VH',
  VL: 'VL',
} as const;
